"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkout = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const small_modal_wrapper_1 = require("../basic/small-modal-wrapper");
const commonModalBody = {
    px: [4, '40px'],
    pt: [4, '30px'],
    pb: [4, '40px'],
};
exports.checkout = (0, basic_1.applyBase)({
    checkoutWaitingScreenWrapper: {
        h3: Object.assign(Object.assign({ maxWidth: ['275px', '465px'], mx: [4, 'auto'] }, font_faces_1.FONT_SIZE.L), { textAlign: 'center', letterSpacing: '1.4px', mb: [3, 4] }),
        '.product-details': {
            textAlign: 'center',
            '.product-name': Object.assign({}, font_faces_1.FONT_SIZE.M),
            '& div': {
                color: 'initial',
            },
            '& div:not(:last-child):after': {
                content: "'/'",
                ml: 2,
            },
        },
        span: {
            borderTop: '2px dashed',
            borderColor: 'primary',
            height: '6px',
            flexGrow: 1,
            marginLeft: ['-40px', '-50px'],
        },
        '.flight-icon-wrapper': {
            display: 'flex',
            alignItems: 'center',
            mb: [3, '28px'],
            ml: [4, 0],
            overflow: 'hidden',
            '.checkout-waiting-screen-icon': {
                color: 'primary',
                width: ['35px', '48px'],
                height: ['32px', '43px'],
                mr: 1,
                transform: 'rotate(20deg)',
                backgroundColor: 'white',
                position: 'relative',
                animation: ['flightMove 4s infinite', 'flightMove 5s infinite'],
                '@keyframes flightMove': {
                    from: { left: '0px' },
                    to: { left: '100%' },
                },
            },
        },
        '.subtitle-text': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.S), { letterSpacing: [null, '0.7px'], mb: [2, 3], variant: 'text.richText' }),
        '.rich-text': {
            variant: 'text.richText',
            'ul li': Object.assign(Object.assign({ listStyle: 'none', pl: ['30px', '35px'], ml: '0px', mb: 2, position: 'relative' }, font_faces_1.FONT_SIZE.LARGE), { '&:before': {
                    content: '""',
                    position: 'absolute',
                    left: '0',
                    top: ['3px', 1],
                    width: ['20px', '25px'],
                    height: ['20px', '25px'],
                    backgroundImage: 'url("/images/svg/Success-red.svg")',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                } }),
        },
    },
    content: {
        display: 'flex',
        flexWrap: ['wrap', 'nowrap'],
        mx: [4, 0],
        '.img-wrap': {
            width: ['100%', '460px'],
            mr: [null, '30px'],
            mb: [3, 0],
            flexShrink: [null, '0'],
            '& .checkout-waiting-screen-img': {
                height: ['175px', '290px'],
                width: '100%',
                objectFit: 'cover',
                display: 'block',
            },
        },
    },
    checkoutNoResults: {
        padding: '0',
        '.title': {
            fontSize: 3,
            mb: 2,
        },
        p: {
            mb: 4,
        },
        button: {
            width: '100%',
        },
    },
    checkoutResultsWrapper: {
        '.title': {
            fontSize: 4,
            mb: 3,
        },
        p: {
            mb: 2,
            fontSize: [null, 3],
        },
    },
    flightSectionWrapper: {
        px: [0, 3],
        mb: 2,
    },
    checkoutResultsFlex: {
        display: 'flex',
        justifyContent: 'flex-end',
        pt: [3, 2],
        '.link-btn': {
            mr: 4,
        },
    },
    checkoutWaitingScreenModal: {
        '.modal-wrapper': {
            maxWidth: [null, '970px'],
            borderRadius: 'default',
            mx: [4, 0],
            alignSelf: 'center',
        },
        '.modal-body': {
            pt: [2, '30px'],
            pb: [2, '45px'],
            px: [0, '45px'],
        },
    },
    checkoutNoResultsModal: {
        '.modal-header': {
            display: 'none',
        },
        '.modal-wrapper': small_modal_wrapper_1.smallModalWrapper,
        '.modal-body': commonModalBody,
    },
    checkoutResultsModal: {
        '.modal-header': {
            display: 'none',
        },
        '.modal-wrapper': small_modal_wrapper_1.smallModalWrapper,
        '.modal-body': commonModalBody,
    },
});
//# sourceMappingURL=checkout.js.map